import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { BodyListResponse } from 'src/app/core/models/general/body-list-response';
import { BodyResponse } from 'src/app/core/models/general/body-response';
import { CatalogoGeneralTipoNivelDTO } from 'src/app/core/models/vinculacion/vinculacion-Interfaces';
import { environment } from 'src/environments/environment';

const API_URL = environment.apiUrlVinculacion;

@Injectable()
export class CatalogoGeneralTipoNivelService {
  header = new Headers({ 'Content-Type': 'application/json' });

  constructor(private http: HttpClient) { }

  getCatalogoGeneralTipoNivelService(): Observable<BodyListResponse<CatalogoGeneralTipoNivelDTO>> {
    return this.http.get<BodyListResponse<CatalogoGeneralTipoNivelDTO>>(API_URL + '/api/v1/catalogoGeneralTipoNivel/todos');
  }

  guardarCatalogoGeneralTipoNivelService(catalogoGeneralTipoNivelDTO: CatalogoGeneralTipoNivelDTO): Observable<BodyResponse<CatalogoGeneralTipoNivelDTO>> {
    return this.http.post<any>(API_URL + '/api/v1/catalogoGeneralTipoNivel', catalogoGeneralTipoNivelDTO);
  }

  getCatalogoGeneralTipoNivelPorCodigoService(codigo: string): Observable<BodyResponse<CatalogoGeneralTipoNivelDTO>> {
    return this.http.get<BodyResponse<CatalogoGeneralTipoNivelDTO>>(API_URL + '/api/v1/catalogoGeneralTipoNivel/' + codigo);
  }

  obtenerPorCatalogoGeneralService(codigo: string): Observable<BodyListResponse<CatalogoGeneralTipoNivelDTO>> {
    return this.http.get<BodyListResponse<CatalogoGeneralTipoNivelDTO>>(API_URL + '/api/v1/catalogoGeneralTipoNivel/buscarPorCatalogoGeneral/' + codigo);
  }
}
